import React, { useEffect, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextField, Grid, Button, Typography, Box, CircularProgress } from '@material-ui/core';

import TituloPagina from '../../components/layout/TituloPagina';
import If from '../../components/condicional/if';
import { getVersao, addVersao, atualizarVersao } from '../../store/actions/versaoApp';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

const VersaoCadastro = props => {
    const history = useHistory();
    const location = useLocation();
    const {
        getVersao,
        addVersao,
        atualizarVersao,
        versao,
        loading,
        processing
    } = props;
    const [disableFields, setDisableFields] = useState(false);
    const [processingMessage, setProcessingMessage] = useState('');

    useEffect(() => {
        const id = Number(location?.state?.versaoAppId);
        const isEditRoute = location.pathname === '/versoes-app/editar-versao';

        if (isEditRoute && !id) {
            history.replace('/versoes-app');
            return;
        }

        if (id > 0) {
            getVersao(id);
        }
    }, [getVersao, history, location]);

    const validationSchema = yup.object({
        versaoMaisRecente: yup.string()
            .required('Informe a versão mais recente/atual do aplicativo'),
        versaoMinimaObrigatoria: yup.string()
            .required('Informe a versão mínima obrigatória para funcionamento do aplicativo'),
        resumoAtualizacao: yup.string()
            .required('Descreva um resumo das atualizações'),
    });

    const formik = useFormik({
        initialValues: {
            id: versao?.id ?? '',
            versaoMaisRecente: versao?.versaoMaisRecente ?? '',
            versaoMinimaObrigatoria: versao?.versaoMinimaObrigatoria ?? '',
            resumoAtualizacao: versao?.resumoAtualizacao ?? '',
            dataCadastro: versao?.dataCadastro ?? ''
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {

            setProcessingMessage('Salvando...');

            if (versao.id > 0) {
                atualizarVersao(values);
            } else {
                addVersao(values);
            }

            setProcessingMessage('');
            setDisableFields(true);
        },
        enableReinitialize: true,
    });

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <Box sx={{ height: '70vh' }}>
            <TituloPagina titulo='Cadastro de Versão do App' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Grid container item xs={12}>

                <Grid container style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                    <Typography variant='body1' component='p'>
                        Indique os dados da versão do aplicativo abaixo.
                    </Typography>
                </Grid>

                <form onSubmit={formik.handleSubmit} noValidate autoComplete='off' style={{ width: 'inherit' }}>
                    <div style={{ flexGrow: 1, paddingTop: '15px' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id='versaoMaisRecente'
                                    name='versaoMaisRecente'
                                    label='Versão mais recente'
                                    variant='filled'
                                    disabled={disableFields}
                                    value={formik.values.versaoMaisRecente}
                                    onChange={formik.handleChange}
                                    error={formik.touched.versaoMaisRecente && Boolean(formik.errors.versaoMaisRecente)}
                                    helperText={formik.touched.versaoMaisRecente && formik.errors.versaoMaisRecente} />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id='versaoMinimaObrigatoria'
                                    name='versaoMinimaObrigatoria'
                                    label='Versão mínima obrigatória'
                                    variant='filled'
                                    disabled={disableFields}
                                    value={formik.values.versaoMinimaObrigatoria}
                                    onChange={formik.handleChange}
                                    error={formik.touched.versaoMinimaObrigatoria && Boolean(formik.errors.versaoMinimaObrigatoria)}
                                    helperText={formik.touched.versaoMinimaObrigatoria && formik.errors.versaoMinimaObrigatoria} />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <TextField
                                    fullWidth
                                    id='resumoAtualizacao'
                                    name='resumoAtualizacao'
                                    label='Resumo da atualização'
                                    variant='filled'
                                    disabled={disableFields}
                                    value={formik.values.resumoAtualizacao}
                                    onChange={formik.handleChange}
                                    error={formik.touched.resumoAtualizacao && Boolean(formik.errors.resumoAtualizacao)}
                                    helperText={formik.touched.resumoAtualizacao && formik.errors.resumoAtualizacao} />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    id='dataCadastro'
                                    name='dataCadastro'
                                    label='Data do Cadastro'
                                    variant='filled'
                                    disabled={true}
                                    value={formik.values.dataCadastro}
                                />
                            </Grid>

                        </Grid>
                        <Grid container pt={4} style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                            <If test={!disableFields}>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button type='submit' color='secondary' variant='contained'>Salvar</Button>
                                </Grid>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button variant='contained' href={'/versoes-app'}>Cancelar</Button>
                                </Grid>
                            </If>
                            <If test={disableFields}>
                                <Grid item style={{ paddingRight: '15px' }}>
                                    <Button color='secondary' variant='contained' href={'/versoes-app'}>Voltar</Button>
                                </Grid>
                            </If>
                        </Grid>
                    </div>
                </form>
            </Grid>

            {/* O componente Loading fica ouvindo o estado isProcessing */}
            <LoadingOverlay
                open={processing}
                message={processingMessage}
            />
        </Box>
    )
}

const mapStateToProps = state => ({
    versao: state.versaoApp.versao,
    loading: state.versaoApp.loading,
    processing: state.versaoApp.processing,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getVersao,
    addVersao,
    atualizarVersao
}, dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(VersaoCadastro);